import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { walletService } from '../../_services/wallet.service';
import { normalizeGiftCard } from './useWallet';
import ChooseDesignModal from './ChooseDesignModal';
import './Wallet.css';
import './ClaimGiftCard.css';

const GiftIcon = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <rect x="3" y="8" width="18" height="13" rx="1.5" />
    <path d="M3 12h18M12 8v13" />
    <path d="M12 8S10.5 3.5 8 4.2C6.2 4.7 6.5 7.5 9 8M12 8s1.5-4.5 4-3.8c1.8.5 1.5 3.3-1 3.8" />
  </svg>
);
const CheckIcon = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M5 13l4 4L19 7" />
  </svg>
);

// ClaimGiftCard — the email-link / deep-link entry point: /gift-cards/claim/:code
// Flow: signed out -> prompt sign-in; signed in -> bind the card to the wallet,
// then (if it has no design) choose one.
//
// CTO INTEGRATION: claimGiftCard binds the code to the user (mock for now);
// resuming the claim AFTER sign-in (so the email link "just works") needs the
// auth flow to honour the stored `pendingGiftCardClaim` / a returnTo.
const ClaimGiftCard = () => {
  const { code } = useParams();
  const history = useHistory();
  const [phase, setPhase] = useState('checking'); // checking|signin|claiming|choose|done|error
  const [item, setItem] = useState(null);

  useEffect(() => {
    const authed = !!localStorage.getItem('accessToken');
    if (!authed) {
      try { localStorage.setItem('pendingGiftCardClaim', code || ''); } catch (e) { /* noop */ }
      setPhase('signin');
      return;
    }
    setPhase('claiming');
    walletService.claimGiftCard(code)
      .then((card) => {
        setItem(normalizeGiftCard(card));
        setPhase(card.designId ? 'done' : 'choose');
      })
      .catch(() => setPhase('error'));
  }, [code]);

  const onChosen = (designId) => {
    if (item) walletService.setGiftCardDesign(item.id, designId);
    history.push('/dashboard/wallet');
  };
  const goWallet = () => history.push('/dashboard/wallet');

  return (
    <div className="claim-page">
      <div className="claim-card">
        {(phase === 'checking' || phase === 'claiming') && (
          <>
            <div className="wallet-spinner" aria-hidden />
            <p className="claim-text">{phase === 'claiming' ? 'Adding your gift card…' : 'Just a moment…'}</p>
          </>
        )}

        {phase === 'signin' && (
          <>
            <div className="claim-icon"><GiftIcon /></div>
            <h1 className="claim-title">You’ve been sent a gift card</h1>
            <p className="claim-text">Sign in to add it to your wallet and choose your design.</p>
            <button type="button" className="wallet-cta claim-cta" onClick={() => history.push('/login')}>Sign in</button>
          </>
        )}

        {phase === 'choose' && (
          <>
            <div className="claim-icon"><CheckIcon /></div>
            <h1 className="claim-title">Gift card added</h1>
            <p className="claim-text">Now choose a design to make it yours.</p>
          </>
        )}

        {phase === 'done' && (
          <>
            <div className="claim-icon"><CheckIcon /></div>
            <h1 className="claim-title">Added to your wallet</h1>
            <p className="claim-text">Your gift card is ready to use.</p>
            <button type="button" className="wallet-cta claim-cta" onClick={goWallet}>View wallet</button>
          </>
        )}

        {phase === 'error' && (
          <>
            <h1 className="claim-title">We couldn’t find that gift card</h1>
            <p className="claim-text">The code may be wrong or it’s already been claimed.</p>
            <button type="button" className="wallet-cta claim-cta" onClick={goWallet}>Go to wallet</button>
          </>
        )}
      </div>

      {phase === 'choose' && item && (
        <ChooseDesignModal item={item} onClose={goWallet} onChosen={onChosen} />
      )}
    </div>
  );
};

export default ClaimGiftCard;
